import { http } from "./http";

export const aiApi = {
  evaluate: (payload) => http.post("/ai/evaluate", payload).then((r) => r.data),
};
